import { Box, Typography } from '@mui/material';

export const UnreadPill: React.FC<{ count: number; open: boolean }> = ({ count, open }) => (
  <Box
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 0.5,
      padding: '2px 8px',
      borderRadius: '20px',
      backgroundColor: '#4DBB21',
      color: 'white',
      fontWeight: 500,
      fontSize: '14px',
    }}
  >
    {/* <ChatBubbleOutline sx={{ fontSize: 18 }} /> */}
    <img src="/assets/svg/speech-bubble-icon.svg" alt="Chat" style={{ width: 13, height: 13 }} />
    {}
    <Typography sx={{ fontWeight: 500, fontSize: '14px', fontFamily: 'Roboto, sans-serif', color: 'white' }}>
      {count}
    </Typography>
  </Box>
);
